import { Modal, Button } from "react-bootstrap"

export const MessageModal = ({ unviewedMessages, onUnviewedMessagesChanged }: { unviewedMessages: MessageAlert[]; onUnviewedMessagesChanged: (updateFunc: (existingMessages: MessageAlert[]) => MessageAlert[]) => void }): React.ReactElement => {
    return (
        <Modal centered size='lg' show={!!unviewedMessages.length} onHide={() => onUnviewedMessagesChanged((existing) => [...existing.slice(0, existing.length - 1)])}>
            <Modal.Header style={{ backgroundColor: unviewedMessages[unviewedMessages.length - 1]?.backgroundcolor }}>
                <Modal.Title>{unviewedMessages[unviewedMessages.length - 1]?.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{unviewedMessages[unviewedMessages.length - 1]?.message}</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => onUnviewedMessagesChanged((existing) => [...existing.slice(0, existing.length - 1)])}>
                    Continue
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export interface MessageAlert {
    title: string | React.ReactElement;
    message: string | React.ReactElement;
    backgroundcolor?: string;
}
